import React from 'react';
import { Provider } from 'react-redux';
import App from './components/App';
import { IntlProvider } from './components/Intl';
import { ExperimentProvider } from './components/Experiment';

/**
 * Basic provider wrapping. This has been externalized in order to
 * enable hot module replacement features.
 */

/* istanbul ignore next */
function Root({ store }) {
  return (
    <Provider store={store}>
      <IntlProvider>
        <ExperimentProvider>
          <App />
        </ExperimentProvider>
      </IntlProvider>
    </Provider>
  );
}

export default Root;
